import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createCommentVNode as _createCommentVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = ["aria-expanded"]
const _hoisted_2 = {
  key: 0,
  class: "flex flex-shrink-0 items-center"
}
const _hoisted_3 = {
  key: 1,
  class: "flex w-full items-center justify-between overflow-x-hidden text-left"
}
const _hoisted_4 = { class: "flex items-center gap-2" }

import { ChevronDownIcon } from '@klausapp/ui-kit/icons'
import { ref, computed, watch } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'UiCollapsiblePanel',
  props: {
    collapsed: { type: Boolean },
    disabled: { type: Boolean },
    collapseToggleFull: { type: Boolean },
    contentClass: {},
    panelClass: {},
    panelExpandedClass: {},
    hasAppendix: { type: Boolean },
    hideChevronIcon: { type: Boolean },
    fullWidth: { type: Boolean },
    titleLink: { type: Boolean }
  },
  emits: ["toggle"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const emit = __emit

const isCollapsed = ref(props.collapsed)

const classList = computed(() => {
  if (props.contentClass) return props.contentClass
  return props.collapseToggleFull ? 'mt-2' : 'mt-3'
})

function collapse() {
  if (props.disabled) return

  isCollapsed.value = !isCollapsed.value
  emit('toggle')
}

watch(
  () => props.collapsed,
  (value) => (isCollapsed.value = value),
)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'group/collapsible-panel',
      { 'bg-gray-10': !isCollapsed.value && _ctx.collapseToggleFull, 'hover:bg-gray-10 mb-2 rounded-md': _ctx.collapseToggleFull },
      _ctx.panelClass,
      !isCollapsed.value && _ctx.panelExpandedClass,
    ])
  }, [
    _createElementVNode("button", {
      class: _normalizeClass([
        'text-gray-60 group/collapsible-panel-button',
        { 'cursor-default': _ctx.disabled, 'text-gray-80': _ctx.collapseToggleFull, 'w-full': _ctx.fullWidth || _ctx.collapseToggleFull },
        _ctx.hasAppendix && 'bg-zblue-10 hover:bg-zblue-10',
        _ctx.titleLink ? 'px-0 py-0' : 'px-2 py-2',
      ]),
      type: "button",
      "aria-expanded": !isCollapsed.value,
      onClick: collapse
    }, [
      (_ctx.$slots.appendix)
        ? _renderSlot(_ctx.$slots, "appendix", { key: 0 })
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(['flex w-full items-center gap-2', { 'justify-between': _ctx.collapseToggleFull }])
      }, [
        _renderSlot(_ctx.$slots, "trigger", {}, () => [
          (_ctx.$slots.icon || _ctx.$slots.title)
            ? (_openBlock(), _createElementBlock("span", {
                key: 0,
                class: _normalizeClass([
              _ctx.collapseToggleFull ? 'flex items-center gap-2.5 overflow-hidden text-xs' : 'text-xxs',
              _ctx.titleLink ? 'content-link !inline-flex !items-center !gap-2 !text-sm' : 'text-default font-bold',
            ])
              }, [
                (_ctx.$slots.icon)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                      _renderSlot(_ctx.$slots, "icon")
                    ]))
                  : _createCommentVNode("v-if", true),
                (_ctx.$slots.title)
                  ? _renderSlot(_ctx.$slots, "title", { key: 1 })
                  : _createCommentVNode("v-if", true)
              ], 2 /* CLASS */))
            : _createCommentVNode("v-if", true),
          (_ctx.$slots.customContent)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _renderSlot(_ctx.$slots, "customContent")
              ]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_4, [
            _renderSlot(_ctx.$slots, "action-menu", { panelCollapsed: isCollapsed.value }),
            (!_ctx.disabled && !_ctx.hideChevronIcon)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass([
                'flex items-center justify-center p-1',
                {
                  'rotate-180': !isCollapsed.value,
                  'rounded-full leading-[0] mix-blend-multiply': _ctx.collapseToggleFull,
                },
              ])
                }, [
                  _createVNode(_unref(ChevronDownIcon), {
                    class: _normalizeClass(_ctx.titleLink ? 'text-zblue-60 icon-m' : 'text-gray-60 icon-s')
                  }, null, 8 /* PROPS */, ["class"])
                ], 2 /* CLASS */))
              : _createCommentVNode("v-if", true)
          ])
        ])
      ], 2 /* CLASS */),
      (_ctx.$slots.dispute)
        ? _renderSlot(_ctx.$slots, "dispute", { key: 1 })
        : _createCommentVNode("v-if", true),
      (_ctx.$slots.evaluation)
        ? _renderSlot(_ctx.$slots, "evaluation", { key: 2 })
        : _createCommentVNode("v-if", true)
    ], 10 /* CLASS, PROPS */, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass([
        'opacity-1 flex max-h-[9999999999px] flex-col pb-2 transition-all',
        isCollapsed.value ? 'mt-0 !max-h-0 overflow-hidden !pb-0 opacity-0' : classList.value,
        _ctx.titleLink ? 'duration-[100ms]' : 'duration-[600ms]',
      ])
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2 /* CLASS */)
  ], 2 /* CLASS */))
}
}

})